import { AddToCartProductStockUnavailable, CartMissingAuthToken } from '@scalefast/core';
const CART_EXCEPTIONS = [{
  errorCode: '1',
  exception: new AddToCartProductStockUnavailable()
}, {
  errorCode: '2',
  exception: new AddToCartProductStockUnavailable()
}, {
  errorCode: '403',
  exception: new CartMissingAuthToken()
}];
export default CART_EXCEPTIONS;
